module.exports = __webpack_public_path__ + "img/information.9c08425f.svg";